












import { Result } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TuandcoResultPrice extends Vue {
  @Prop()
  item: Result;

  get valueHTML(): string {
    const priceWithCurrency: string = this.$options.filters.currency(
      this.item.price.value
    ); // 10,57 €
    return priceWithCurrency
      .replace(
        /,(\d{2})/,
        ',<span class="ebx-result-price__value-decimals">$1</span>'
      )
      .replace(
        /[$£€]/,
        '<span class="ebx-result-price__value-currency">$&</span>'
      );
  }
}
